// Lib imports
import Vue from 'vue';
import Router from 'vue-router';

import store from '../store';
import routes from './routes';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior(to) {
    return (to.hash) ? { selector: to.hash } : undefined;
  },
});
router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters['auth/isLoggedIn'];
  const privateEventPages = [
    'BecomeSponsorEvent', 'Meeting Rooms', 'Booked Tables', 'Exhibitors', 
    'Venue', 'Agenda', 'Map', 'Info', 'Media', 'Companies', 'BecomePannelist',
    'Speakers', 'Accommodation', 'BookEventDetails'
  ];
  const publicEventsPages = ['PublicMeeting Rooms', 'PublicBooked Tables',
    'PublicExhibitors', 'PublicVenue', 'PublicAgenda', 'PublicMap', 'PublicInfo', 'PublicMedia',
    'PublicCompanies', 'PublicBecomeSponsorEvent', 'PublicBecomePannelist', 'PublicSpeakers',
    'PublicAccommodation', 'PublicBookEventDetails'
  ];

  if (to.name === 'PublicEvents' && isLoggedIn) {
    next({ name: 'ccAllEvents' });
    return;
  } if (to.name === 'ccAllEvents' && !isLoggedIn) {
    next({ name: 'PublicEvents' });
    return;
  }

  if (publicEventsPages.includes(to.name) && isLoggedIn) {
    next({ name: to.name.replace('Public', ''), params: to.params });
  } else if (privateEventPages.includes(to.name) && !isLoggedIn) {
    const publicRouteName = `Public${to.name}`;
    const routeExists = router.options.routes.some(route => route.name === publicRouteName || (route.children && route.children.some(child => child.name === publicRouteName)));
    next({ name:  routeExists ? publicRouteName : 'signIn', params: to.params, query: { redirectBack: to.fullPath } });
  } else if (to.meta.ignoreGate) {
    next();
  } else if (to.meta.isPublicPage) {
    if (!isLoggedIn) {
      next();
    } else {
      next({ name: 'ccAllEvents' });
    }
  } else if (to.matched.some(record => record.meta.requiresAuth)) {
    if (isLoggedIn) {
      next();
    } else {
      next({ name: to.name === 'PersonalWall' ? 'PublicEvents' : 'signIn', query: { redirectBack: to.fullPath } });
    }
  } else if (isLoggedIn && !to.matched.some(record => record.meta.isDownloadRoute) &&  to.name !== 'Settings/MobileRedirect') {
    next({ name: 'PersonalWall' });
  } else {
    next();
  }
});

export default router;
